export default __webpack_public_path__ + "static/media/pid.b38753bc.svg";